import React from 'react';
import { Search, PenTool, Target } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const steps = [{
  num: '1',
  icon: Search,
  title: 'Audita',
  desc: 'Identifica tus activos invisibles y tradúcelos al lenguaje "Remote-First".'
}, {
  num: '2',
  icon: PenTool,
  title: 'Posiciona',
  desc: 'Optimiza tu CV y LinkedIn usando el Método de Cero Fricción.'
}, {
  num: '3',
  icon: Target,
  title: 'Cierra',
  desc: 'Aplica a las plataformas correctas y domina la entrevista demostrando confiabilidad absoluta.'
}];
export function HowItWorks() {
  return <section className="py-24 px-4 bg-navy-900" data-id="element-83">
      <div className="max-w-5xl mx-auto" data-id="element-84">
        <FadeIn data-id="element-85">
          <div className="text-center mb-16" data-id="element-86">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-87">
              Cómo funciona
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-88">
              Un proceso lineal, claro y sin relleno para que empieces a ver
              resultados en 30 días.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-89">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-navy-700 via-accent-500/30 to-navy-700 z-0" data-id="element-90" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-91">
                <div className="flex flex-col items-center text-center" data-id="element-92">
                  <div className="w-24 h-24 rounded-full bg-navy-800 border-2 border-accent-500/30 flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(34,211,238,0.1)] relative" data-id="element-93">
                    <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-accent-500 text-navy-900 font-bold flex items-center justify-center font-heading" data-id="element-94">
                      {step.num}
                    </div>
                    <Icon className="w-10 h-10 text-accent-400" data-id="element-95" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4" data-id="element-96">
                    {step.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-97">{step.desc}</p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.6} className="mt-20" data-id="element-98">
          <div className="bg-accent-500/10 border border-accent-500/20 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-99">
            <h4 className="text-xl font-bold text-accent-400 mb-2" data-id="element-100">
              Lo que cambia en 30 días:
            </h4>
            <p className="text-lg text-slate-300" data-id="element-101">
              Pasarás de enviar 100 aplicaciones sin respuesta a generar
              entrevistas calificadas donde el tema no será tu ubicación, sino
              cómo vas a empezar a optimizar los procesos de la empresa desde el
              primer día.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}